import styled from "styled-components";
import {Select} from "antd";
export const SelectField = styled(Select)`
    width: 100%;
    margin-bottom: 20px;
`;
